const { sanitizeVersion } = require("./index")

/**
 * Compares two platform version numbers (e.g. "1.7.1" or "1.2").
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @returns {number|NaN}
 */

function compare(v1, v2) {
    v1 = sanitizeVersion(v1)
    v2 = sanitizeVersion(v2)

    if (!v1 || !v2) return NaN

    let v1parts = v1.split(".")
    let v2parts = v2.split(".")

    v1parts = v1parts.map(Number)
    v2parts = v2parts.map(Number)

    for (let i = 0; i < v1parts.length; ++i) {
        if (v2parts.length === i) {
            return 1
        }
        if (v1parts[i] === v2parts[i]) {
            continue
        } else if (v1parts[i] > v2parts[i]) {
            return 1
        } else {
            return -1
        }
    }
    if (v1parts.length !== v2parts.length) {
        return -1
    }
    return 0
}

function matches(v1, v2) {
    return compare(v1, v2) === 0
}
function gt(v1, v2) {
    return compare(v1, v2) > 0
}
function gte(v1, v2) {
    return compare(v1, v2) >= 0
}
function lt(v1, v2) {
    return compare(v1, v2) < 0
}
function lte(v1, v2) {
    return compare(v1, v2) <= 0
}

module.exports = { matches, gt, gte, lt, lte }
